import { Modal } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faMinus, faPlus, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Button } from '../../../components/Button';
import { menuMoney, type DigitalMenuBasketLine } from '../digital-menu.utils';
import classes from '../digital-menu.module.scss';

type Props = { opened: boolean; lines: DigitalMenuBasketLine[]; total: number; onClose: () => void; onQuantity: (key: string, delta: number) => void; onRemove: (key: string) => void };

export function BasketSheet({ opened, lines, total, onClose, onQuantity, onRemove }: Props) {
  return <Modal opened={opened} onClose={onClose} title="הסל שלי" centered size="lg" dir="rtl" closeButtonProps={{ 'aria-label': 'סגירת הסל' }} classNames={{ content: classes.modal }}>
    <div className={classes.basket}>
      {lines.length === 0 && <p className={classes.status}>הסל ריק</p>}
      {lines.map((line) => <article className={classes.basketLine} key={line.key}>
        <div className={classes.basketLineHead}><h3>{line.name}</h3><strong>{menuMoney(line.unitPrice * line.quantity)}</strong></div>
        {line.choices.length > 0 && <p className={classes.muted}>{line.choices.join(' · ')}</p>}
        <div className={classes.basketLineActions}>
          <div className={classes.quantity}>
            <Button variant="icon" ariaLabel={`הגדלת כמות ${line.name}`} disabled={line.quantity >= 99} onClick={() => onQuantity(line.key, 1)}><FontAwesomeIcon icon={faPlus as IconProp} /></Button>
            <output aria-label={`כמות ${line.name}`}>{line.quantity}</output>
            <Button variant="icon" ariaLabel={`הקטנת כמות ${line.name}`} onClick={() => onQuantity(line.key, -1)}><FontAwesomeIcon icon={faMinus as IconProp} /></Button>
          </div>
          <Button variant="icon" ariaLabel={`הסרת ${line.name} מהסל`} onClick={() => onRemove(line.key)}><FontAwesomeIcon icon={faTrashCan as IconProp} /></Button>
        </div>
      </article>)}
      {lines.length > 0 && <div className={classes.basketTotal}><span>סך הכול</span><strong>{menuMoney(total)}</strong></div>}
    </div>
  </Modal>;
}